/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */
import { put, call, takeEvery } from "redux-saga/effects";
import {
  PROPERTY_PARSE,
  PROPERTY_PARSE_FAILURE,
  PROPERTY_PARSE_SUCCESS,
} from "../actions/actionTypes";
import { PropertyManagement } from "../api/agent";
function* propParser(action) {
  try {
    const payload = yield call(PropertyManagement.uploadFile, action.payload);
    yield put({ type: PROPERTY_PARSE_SUCCESS, payload });
  } catch (err) {
    const errResp = err.response.body;
    yield put({ type: PROPERTY_PARSE_FAILURE, errResp });
  }
}

export function* watchPropParser() {
  yield takeEvery(PROPERTY_PARSE, propParser);
}
